/** Ensures only one ModernDialogHost handles confirm/prompt (avoids stacked overlays). */

const OWNER_KEY = "__nyufazModernDialogHostOwner";

/** Last mounted host wins (SPA route changes). */
export function claimModernDialogHost(hostId) {
  if (typeof window === "undefined") return true;
  window[OWNER_KEY] = hostId;
  return true;
}

export function releaseModernDialogHost(hostId) {
  if (typeof window === "undefined") return;
  if (window[OWNER_KEY] === hostId) window[OWNER_KEY] = null;
}
